module.exports = __webpack_public_path__ + "img/Undo-icon.5826940d.svg";